export enum RouteStatus {
  CREATED = 'CREATED',
  ASSIGNED = 'ASSIGNED',
  ACTIVE = 'ACTIVE',
  STARTED = 'STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  PAUSED = 'PAUSED',
  PENDING_DRIVER_CONFIRMATION = 'PENDING_DRIVER_CONFIRMATION',
  PENDING_HERMES_ASSIGN = 'PENDING_HERMES_ASSIGN',
  CLOSED = 'CLOSED',
}

export const RouteStatusLabels: Record<RouteStatus, string> = {
  [RouteStatus.CREATED]: 'Creada',
  [RouteStatus.ASSIGNED]: 'Asignada',
  [RouteStatus.ACTIVE]: 'Activa',
  [RouteStatus.STARTED]: 'Iniciada',
  [RouteStatus.IN_PROGRESS]: 'En curso',
  [RouteStatus.COMPLETED]: 'Completada',
  [RouteStatus.CANCELLED]: 'Cancelada',
  [RouteStatus.PAUSED]: 'Pausada',
  [RouteStatus.PENDING_DRIVER_CONFIRMATION]: 'Pendiente confirmación',
  [RouteStatus.PENDING_HERMES_ASSIGN]: 'Procesando (Hermes)',
  [RouteStatus.CLOSED]: 'Cerrada',
};
